//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMerchantBills } from '@/api/alliance';
export default {
  name: 'AllianceMerchantBills',
  data: function data() {
    return {
      loading: false,
      granularity: 'DAY',
      dateRange: [],
      list: [],
      total: 0,
      page: {
        page: 1,
        size: 20
      }
    };
  },
  created: function created() {
    this.load(1);
  },
  methods: {
    yuan: function yuan(fen) {
      return '￥' + (Number(fen || 0) / 100).toFixed(2);
    },
    onGranularityChange: function onGranularityChange() {
      // 切粒度时清掉时间区间：按日选的那 7 天放到按月上只会剩一行，看着像数据丢了
      this.dateRange = [];
      this.load(1);
    },
    load: function load(page) {
      var _this = this;
      if (page) this.page.page = page;
      var params = {
        granularity: this.granularity,
        page: this.page.page,
        size: this.page.size
      };
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = this.dateRange[1];
      }
      this.loading = true;
      getMerchantBills(params).then(function (res) {
        _this.list = res && res.list || [];
        _this.total = res && res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    onSizeChange: function onSizeChange(size) {
      this.page.size = size;
      this.load(1);
    },
    reset: function reset() {
      this.dateRange = [];
      this.granularity = 'DAY';
      this.load(1);
    },
    summary: function summary(_ref) {
      var _this2 = this;
      var columns = _ref.columns;
      return columns.map(function (column, index) {
        if (index === 0) {
          return '本页合计';
        }
        var sum = _this2.list.reduce(function (acc, row) {
          return acc + Number(row[column.property] || 0);
        }, 0);
        if (column.property === 'cnt' || column.property === 'deductPoints') {
          return sum;
        }
        return _this2.yuan(sum);
      });
    }
  }
};